<template>
  <section>
    <navbar-public></navbar-public>
    <div class="ew-smaller-container">
      <div v-if="result === 'success' && from" class="ew-card">
        {{addEventPixeleFacebook()}}
        <h1 class="ew-result__title">Pago exitoso</h1>
        <img src="@/assets/images/15.- Pago-exitoso.svg" alt="" class="ew-result-indicator">
        <p class="ew-result__text">¡Su pago ha sido procesado con éxito!</p>
        <p class="ew-result__text">Revisa tu correo en <strong>{{email}}</strong>: ahí tienes tu guía.</p>
        <router-link v-if="isLoging" to="/dashboard" class="ew-btn-primary">Volver a la página de inicio</router-link>
        <router-link v-else to="/" class="ew-btn-primary">Volver a la página de inicio</router-link>
      </div>
      <div v-if="result === 'success' && paymentMonedero" class="ew-card">
        <h1 class="ew-result__title">Pago exitoso</h1>
        <img src="@/assets/images/15.- Pago-exitoso.svg" alt="" class="ew-result-indicator">
        <p class="ew-result__text">¡Se ha realizado tu pago desde el monedero con <strong>éxito</strong>!</p>
        <router-link v-if="isLoging" to="/dashboard" class="ew-btn-primary">Volver a la página de inicio</router-link>
        <router-link v-else to="/" class="ew-btn-primary">Volver a la página de inicio</router-link>
      </div>
      <div v-if="result === 'success' && paymentConekta" class="ew-card">
        <h1 class="ew-result__title">Pago pendiente</h1>
        <img src="@/assets/images/15.- Pago-exitoso.svg" alt="" class="ew-result-indicator">
        <p class="ew-result__text">Revisa tu correo en <strong>{{email}}</strong>: ahí tienes la referencia para completar tu pago.</p>
        <div class="ew-result__actions">
          <router-link :to="isLoging ? '/dashboard' : '/'" class="ew-btn-primary">Volver a la página de inicio</router-link>
          <router-link :to="'/shipping/cash_barcode?references='+reference" target="_blank" class="ew-btn-outline">Ver referencia de pago</router-link>
        </div>
      </div>

      <div v-if="result === 'error'" class="ew-card">
        <h1 class="ew-result__title">Pago declinado</h1>
        <img src="@/assets/images/16.- Pago declinado.png" alt="" class="ew-result-indicator">
        <p class="ew-result__text">Ocurrió un error durante el proceso de pago.</p>
        <p class="ew-result__text">Por favor intenta nuevamente más tarde.</p>
        <router-link to="/dashboard" class="ew-btn-primary">Volver al panel de usuario</router-link>
      </div>
    </div>

    <footer-public></footer-public>
    <call-float-button></call-float-button>
  </section>
</template>

<script>
import axios from 'axios'
import commons from '../commons'
import NavbarPublic from './Header/NavbarPublic'
import FooterPublic from './Header/FooterPublic'
import CallFloatButton from './Header/CallFloatButton'

export default {
  name: 'PaymentResult',
  data () {
    return {
      result: 'loading',
      from:'',
      email:'',
      paymentConekta:'',
      isLoging:false,
      reference:''
    }
  },
  created () {
    this.getStatusSesion();
    this.from  =  (this.$route.query.home === 'true')?true:false
    this.email  =  this.$route.query.email
    this.result = this.$route.params['result']
    this.paymentConekta = (this.$route.query.oxxo === 'true')?true:false
    this.paymentMonedero = (this.$route.query.monedero === 'true')?true:false
    if (this.$route.query.reference) {
      this.reference = this.$route.query.reference
    }
  },
  methods: {
    getStatusSesion(){
      if (localStorage.getItem('ew-user-id') !== null) {
        this.isLoging = true;
      } else {
        this.isLoging = false;
      }
    },
    getShipment (id) {
      const url = `${commons.apiURL}/api/v1/shipments/${id}`
      return axios.get(url)
    },
    pay (paymentMethod) {
      let myWindow = null
      if (paymentMethod === 'paypal') {
        axios
          .post(`${commons.apiURL}/api/v1/payments/${this.shipmentId}`)
          .then(response => {
            myWindow = window.open(
              response.data.url,
              'Moovet - PayPal',
              'centerscreen,modal'
            )
            myWindow.focus()
          })
      }
    },
    addEventPixeleFacebook(){
      fbq('track', 'Purchase', {value: 0.00, currency: 'USD'});
    }
  },
  mounted(){
    try {
      Tawk_API.hideWidget();
    } catch (error) {

    }
  },
  computed: {},
  components: {
    'navbar-public': NavbarPublic,
    'footer-public': FooterPublic,
    'call-float-button': CallFloatButton
  }
}
</script>

<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-smaller-container { @include app-tokens; max-width: 600px; margin: 4rem auto; padding: 0 1rem; }
.ew-card { @include ew-card; padding: 2rem 1.75rem; text-align: center; margin-bottom: 1.25rem; }
.ew-btn-primary { @include ew-btn-primary; }
.ew-btn-outline { @include ew-btn-outline; }

.ew-result__title {
  font-family: var(--app-font);
  font-weight: 700;
  font-size: 1.4rem;
  color: var(--app-navy);
  border-bottom: 1px solid var(--app-border);
  padding-bottom: 1rem;
  margin-bottom: 0.75rem;
}

.ew-result__text {
  font-family: var(--app-font);
  color: var(--app-navy-secondary);
}

.ew-result-indicator {
  width: 8rem;
  margin: 1rem 0;
}

.ew-result__actions {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/PaymentResult.vue